import { findProductsByCompany, findProductsAll } from '../../_services/product.service';
import { findProductsPriceByClient } from '../../_services/product_price.service';
import { getCompany } from '../../_utils/storage_handler';

export const findProductsByCompanyEvent = async () => {
    let res = await findProductsByCompany(getCompany());
    if(!res.ok){
        throw new Error(res.error);
    }
    
    return res;
}

export const findProductsAllEvent = async () => {
    let res = await findProductsAll();
    if(!res.ok){
        throw new Error(res.error);
    }
    
    return res;
}

export const findProductsPriceByClientEvent = async (client) => {
    let res = await findProductsPriceByClient(client);
    if(!res.ok){
        throw new Error(res.error);
    }
    
    return res;
}